<template>
  <div class="m-consumption">
    <div class="u-toptilte">
      <p><i style="color:#FFCC00">▎</i>提现记录</p>
    </div>
    <div v-if="!zanwusj">
      <div :data="withdrawals">
        <!-- <el-table-column label="上机时间" prop="create_at" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.create_at
                .split("T")
                .join(" ")
                .split("+")
                .shift()
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="下机时间" prop="delete_at" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.delete_at
                .split("T")
                .join(" ")
                .split("+")
                .shift()
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="消耗点数"
          prop="spendpoints"
          align="center"
        ></el-table-column> -->
        <div class="title_all">
          <div>开户行信息</div>
          <div>开户行账号</div>
          <div>提现余额</div>
          <div>提交时间</div>
          <div>审核状态</div>
          <div>审核时间</div>
          <div>操作</div>
        </div>
        <div class="content" v-for="(i, index) in withdrawals" :key="index">
          <div>
            {{i.bank_info}}
          </div>
          <div>
            {{i.bank_account}}
          </div>
          <div>
            {{ i.amount }}
          </div>
          <div>
            {{
              i.commit_time
                .split("T")
                .join(" ")
                .split("+")
                .shift()
                .replace('Z', '')
            }}
          </div>
          <div v-if="i.review_status === 0">待审核</div>
          <div v-else-if="i.review_status === 1">通过</div>
          <div v-else-if="i.review_status === -1">拒绝</div>
          <div v-if="i.review_status !== 0">
            {{
              i.review_time
                .split("T")
                .join(" ")
                .split("+")
                .shift()
                .replace('Z', '')
            }}
          </div>
          <div v-else></div>
          <div v-if="i.review_status === 0">
            <el-button type="danger" size="mini" @click="cancelPost(i.id)">撤销</el-button>
          </div>
          <div v-else></div>
        </div>
      </div>

      <div class="u-btnpage">
        <span>共{{ gongye }}页</span>

        <span>当前{{ dangqianye }}页</span>
        <a @click="shang">上一页</a>
        <a @click="xia">下一页</a>
      </div>
    </div>
    <div v-if="zanwusj" class="no-Order">
      <img draggable="false" src="../../static/percttent/nodd.png" />
      <p>暂无提现记录！</p>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: {
    title: '海星云消费记录，云电脑_云游戏平台_畅玩3A游戏大作-海星云官网',
    meta: [
      {
        name: 'keywords',
        content: '海星云电脑,云游戏,云游戏平台,云游戏免下载,云平台,海星云,云游戏主机,手机玩端游,免费加速器'
      },
      {
        name: 'description',
        content: '海星云无需升级电脑，即可享2080ti, 4K超高画质，低延迟的云游戏体验，支持手机 、平板、PC、TV等全平台畅玩，提供免费加速器，300+款3A大作，无需下载，即点即玩'
      }
    ]
  },
  data () {
    return {
      zanwusj: true,
      token: '',
      withdrawals: ''
    }
  },
  methods: {
    cancelPost (id) {
      this.http.cancelPostWithdrawal(id).then(res => {
        if (res.status === 200 && res.data.code === 200) {
          this.$message({
            message: '撤销成功',
            type: 'success'
          })
        } else {
          this.$message.error('撤销失败，请稍后再试！')
        }
      })
      window.location.reload()
    },
    shang () {
      this.dangqianye = this.dangqianye - 1
      this.http.getWithdrawals(this.dangqianye).then(res => {
        this.withdrawals = res.data.data.withdrawals
      })
      if (this.dangqianye < 1) {
        this.dangqianye = 1
        return false
      }
    },
    xia () {
      this.dangqianye = this.dangqianye + 1
      this.http.getWithdrawals(this.dangqianye).then(res => {
        this.withdrawals = res.data.data.withdrawals
      })
      if (this.dangqianye > this.gongye) {
        this.dangqianye = this.gongye
        return false
      }
    }
  },
  mounted () {
    this.token = this.$cookieStore.getCookie('user_sess')
    if (!this.token) {
      this.$message({
        message: '抱歉！您还没登录',
        type: 'warning'
      })
      this.gongye = 0
      this.dangqianye = 0
      return false
    }
    this.http.getWithdrawals().then(res => {
      this.withdrawals = res.data.data.withdrawals
      this.zanwusj = this.withdrawals.length === 0
      this.dangqianye = res.data.data.cur_page
      this.gongye = res.data.data.total_page
    })
  }
}
</script>
<style scoped>
@media screen and (max-width: 500px) {
  .title_all {
    width: 100% !important;
  }
  .content {
    width: 100% !important;
  }
}
.title_all {
  width: 85%;
  display: flex;
  justify-content: space-around;
  padding: 15px 0 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  margin: 0 auto;
}
.title_all div {
  width: 300px;
  text-align: center;
  font-size: 14px;
  font-weight: 900;
}
.content {
  margin: 0 auto;
  display: flex;
  width: 85%;
  justify-content: space-between;
  padding: 8px 0 8px 0;

  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
}
.content div {
  text-align: center;
  width: 300px;
  font-size: 14px;
}
.content:hover {
  background: #12102f;
}
</style>



// WEBPACK FOOTER //
// src/components/Withdrawal.vue